import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getRevenueTypes = ({ churchId }) => {
  return axios.get(`/churches/${churchId}/revenue-types`);
};

export const useRevenueTypes = ({ churchId, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["revenue-types", churchId],
    queryFn: () => getRevenueTypes({ churchId })
  });
};
